import {
  BusinessGetResponseType,
  StockListRequestType,
  StockListResponseType,
} from "@sellar-io/api-v2/types";
import { ExtendedFirebaseUser } from "../../../../hooks/useFirebaseUser.shared";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../hooks/api/v2/apiV2Request";

export const fetchProducts = <TData = StockListResponseType>({
  user,
  business,
  params,
}: {
  user: ExtendedFirebaseUser | undefined;
  business: BusinessGetResponseType;
  params: StockListRequestType;
}) => {
  return apiV2Request({
    user,
    business,
    method: "get",
    path: `products/stock-list`,
    params: {
      ...params,
    },
  }).then((data) => apiV2AssertResponse<TData>(data).data);
};
